import { create } from "zustand";

/**
 * Cuál de los tres menús de la cabecera está abierto.
 *
 * ── Por qué un store y no estado local ──────────────────────────────────────
 * Los tres botones viven en el `Header`, pero dos de los tres paneles los
 * tiene que pintar `AppsSidebar`, que es quien recibe de cada layout el
 * catálogo de aplicaciones, el usuario y las acciones de cuenta. El `Header`
 * no tiene nada de eso y pasárselo obligaría a tocar los 44 layouts que montan
 * `AppsSidebar`.
 *
 * Un dato compartido —cuál está abierto— resuelve eso sin mover una sola prop.
 *
 * ── Por qué uno solo y no tres banderas ─────────────────────────────────────
 * Porque son excluyentes: abrir avisos cierra aplicaciones. Con tres booleanos
 * eso hay que recordarlo en cada sitio que abre uno, y el día que se olvide
 * salen dos paneles encimados.
 */

export type MenuDeCabecera = "avisos" | "apps" | "cuenta";

interface Estado {
  abierto: MenuDeCabecera | null;
  alternar: (menu: MenuDeCabecera) => void;
  cerrar: () => void;
}

export const useMenusCabecera = create<Estado>((set) => ({
  abierto: null,
  alternar: (menu) => set((s) => ({ abierto: s.abierto === menu ? null : menu })),
  cerrar: () => set({ abierto: null }),
}));
